// importing types from constants definded in constant/ index file
import {
  TOASTER_SHOW,
  TOASTER_HIDE,
  LOADER_SHOW,
  toaster_s,
  toaster_e,
  toaster_w,
} from "../constant/index";

const INITIAL_STATE = {
  show: false,
  type: "",
  heading: "",
  description: [],
  autoHide: false,
};

export default (state = INITIAL_STATE, action) => {
  const payload = action.payload;
  switch (action.type) {
    case TOASTER_SHOW: {
      const description =
        typeof payload?.description === "string"
          ? payload.description.split("<br/>")
          : Array.isArray(payload?.description)
            ? payload.description
            : payload?.description
              ? [String(payload.description)]
              : typeof payload?.text === "string"
                ? [payload.text]
                : typeof payload?.message === "string"
                  ? [payload.message]
                  : [];

      return {
        ...state,
        ...payload,
        show: payload?.show !== false,
        autoHide: payload?.autoHide !== false,
        type: payload?.type || payload?.level || state.type,
        heading: payload?.heading || payload?.title || state.heading,
        description,
      };
    }
    case TOASTER_HIDE:
      return INITIAL_STATE;
    case LOADER_SHOW:
      return state;
  }
  return state;
};
